import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { Link } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";

const ServicesIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "جميع الاسعار",
				breadcrumb: "الاسعار",
				button: {
					show: true,
					text: "اضافة سعر جديد",
					link: "/servicesPrices/create",
				},
			})
		);

		axios
			.get(`${process.env.REACT_APP_API_URL}/pricesList`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setData(response.data.data);
				setLoading(false);
				console.log(response.data.data);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
	};

	const handleDelete = ID => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/pricesList/${ID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				onStart();
				toast.success("تم الحذف بنجاح");
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	return (
		<section>
		  {loading && <Loader />}
		  <section>
			<div className="row">
			  {data?.map(item => (
				<div className="col-md-3" key={item.id}>
				  <div className="serviceItem">
					<button onClick={() => handleDelete(item.id)}>
					  <i className="fas fa-trash"></i>
					</button>
					<Link to={`/servicesPrices/show/${item.id}`} className={`d-flex gap-2 flex-column`}>
					  <img
						src={`${process.env.REACT_APP_MAIN_URL}/${item.image}`}
						alt={item.title?.ar || 'Service Image'}
					  />
					  {item.title?.ar && <h1>{item.title.ar}</h1>}
					  {item.price && <h5>{item.price} <i className="fa fa-dollar-sign change-col"></i> </h5>}
					</Link>
				  </div>
				</div>
			  ))}
			</div>
		  </section>
		</section>
	  );
	  
};

export default ServicesIndex;
